// @ts-ignore
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import { CookieAttributes } from '@/modules/core/app/helpers/types/CookieAttributes';

class CookieHelper {
  get(name: string): string | undefined {
    return Cookies.get(name);
  }

  set(name: string, value: unknown, attributes: CookieAttributes = {}): void {
    Cookies.set(name, value, attributes);
  }

  setWithExpiryInHours(
    name: string,
    value: unknown,
    expiryInHours: number,
    attributes: CookieAttributes = {}
  ): void {
    const expires: Date = dayjs().add(expiryInHours, 'hours').toDate();

    this.set(name, value, { ...attributes, expires });
  }

  remove(name: string): void {
    Cookies.remove(name);
  }
}

export default new CookieHelper();
